/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import store from '@/store';
import { USER } from '@/store/types';
import { finalizeAction, ActionType } from '@/store/actions';
import { UserMedal } from '@/api/types/user';

export interface StoreUserMedalsState {
  metal: UserMedal[];
  finishedCount: number;
  totalCount: number;
  wearHours: number;
}

export default {
  namespaced: true,
  state: {
    medals: null,
    finishedCount: null,
    totalCount: null,
    wearHours: null,
  },
  getters: {},
  actions: {
    [USER.GET_MEDALS]({ state, commit }, { action: rawAction = '' }: { action?: ActionType } = {}) {
      const action = finalizeAction(rawAction, state.medal);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getMedals().then((res) => {
            commit(USER.GET_MEDALS, {
              medals: res.data,
              finishedCount: res.extra.finishedCount,
              totalCount: res.extra.totalCount,
              wearHours: res.extra.wearHours,
            });
            resolve(state.medals);
          }).catch(reject);
        });
      }
      return Promise.resolve(state.meta);
    },
    [USER.EQUIP_MEDAL](_, { id }) {
      return new Promise((resolve, reject) => {
        api.putMedal(id).then(() => {
          store.dispatch(`user/${USER.GET}`, {
            action: 'refresh',
          }).then(resolve).catch(reject);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_MEDALS](state, { medals, finishedCount, totalCount, wearHours }) {
      state.medals = medals;
      state.finishedCount = finishedCount;
      state.totalCount = totalCount;
      state.wearHours = wearHours;
    },
  },
};
